module.exports = __webpack_public_path__ + "img/programme_funeng_pic_operate2@3x.a3f15926.png";